import { render, staticRenderFns } from "./changeText.vue?vue&type=template&id=74c83893"
import script from "./changeText.vue?vue&type=script&lang=js"
export * from "./changeText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports